<template>
  <div>
    <FITFormCard class="w-100">
      <div slot="header">
        <span class="h5"><span class="fa fa-school mr-2"></span>{{ convertToTranslateKey('header') }}</span>
      </div>
      <div slot="formBody">
        <!--      <FITAutoSearch :label="convertToTranslateKey('provider')" dest="provider" :placeholder="convertToTranslateKey('provider')" v-model="form.selectedProvider" :paras="[{ key: 'type', value: 'provider' }]" :showItems="['providerCode', 'providerEnglishName', 'providerChineseName']" :width="columnWidth" :disabled="locked"></FITAutoSearch> -->
        <div class="w-75">
          <FITTextInput :label="convertToTranslateKey('providerName')" v-model="form.providerName" :disabled="locked" :width="columnWidth"></FITTextInput>
          <FITTextInput :label="convertToTranslateKey('trainingName')" v-model="form.trainingName" :disabled="locked" :width="columnWidth"></FITTextInput>
          <FITSelect :label="convertToTranslateKey('trainingType')" :options="trainingType" v-model="form.trainingType" :disabled="locked" :width="columnWidth"></FITSelect>
          <FITDatePicker :label="convertToTranslateKey('trainingDate')" v-model="form.trainingDate" :disabled="locked" :width="columnWidth"></FITDatePicker>
          <FITTimepicker :label="convertToTranslateKey('trainingTime')" v-model="form.trainingTime" :disabled="locked" :width="columnWidth" :init-value="trainingTime"></FITTimepicker>
          <FITTextInput :label="convertToTranslateKey('point')" type="number" v-model="form.point" :disabled="locked" :width="columnWidth"></FITTextInput>
          <div class="w-75">
            <b-row align-v="center" v-for="a, idx in agents" class="py-0 my-0">
              <b-col cols="10">
                <FITAutoSearch :label="convertToTranslateKey('agent')" dest="option" :placeholder="convertToTranslateKey('agent')" v-model="agents[idx]" :paras="[{ key: 'type', value: 'agent' }]" :showItems="['englishFullname', 'chineseFullname', 'agentCode']" :width="columnWidth-1" :disabled="locked"></FITAutoSearch>
              </b-col>
              <b-col cols="auto">
                <b-button variant="danger" @click="removeAgent(idx)"><i class="fas fa-times mr-2"></i>{{ convertToTranslateKey('remove') }}</b-button>
              </b-col>
            </b-row>
            <FITButton class="w-25" @click="addNewAgent" :text="convertToTranslateKey('addAgent')" variant="warning" faIcon="fa-plus"></FITButton>
          </div>
        </div>
      </div>
    </FITFormCard>
    <b-row>
      <b-col cols="12" class="text-right">
        <FITButton @click="submit" :text="convertToTranslateKey((ID === null) ? 'create.header' : 'edit')" variant="primary"></FITButton>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  FITFormCard,
  FITSelect,
  FITTextInput,
  FITDatePicker,
  FITTimepicker,
  FITAutoSearch,
  FITButton
} from '@/components'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Vue from 'vue'
export default {
  name: 'TrainingCreate',
  components: {
    FITFormCard,
    FITSelect,
    FITTextInput,
    FITDatePicker,
    FITTimepicker,
    FITAutoSearch,
    FITButton
  },
  props: {
    ID: {
      type: Number,
      default: null
    }
  },
  mounted() {
    this.$store.dispatch('getAllSelections', 'training')
      .then((result) => {
        var json = result.data;
        this.$store.commit({ type: 'CPD/setSelections', selections: json });
      });

    if (!this.ID) return;

    this.$store.dispatch('CPD/getTrainingDetail', {
      ID: this.ID
    }).then((result) => {
      result = result.data
      var agents = JSON.parse(JSON.stringify(result['agents']));

      // Convert training time to object 
      let trainingTime = result['trainingTime'];
      trainingTime = trainingTime.split(":");
      trainingTime = {
        HH: trainingTime[0],
        mm: trainingTime[1],
        ss: trainingTime[2]
      }

      var newForm = {};
      Object.keys(this.form)
        .forEach((key) => {
          if (result[key]) {
            newForm[key] = result[key]
          }
        });

      newForm['trainingTime'] = trainingTime
      newForm['ID'] = this.ID
      Vue.set(this, 'trainingTime', trainingTime)
      Vue.set(this, 'agents', (agents.length === 0) ? [{ ID: -1 }] : agents);
      Vue.set(this, 'form', newForm);
    })
  },
  methods: {
    addNewAgent() {
      this.agents.push({ ID: -1 });
    },
    removeAgent(index) {
      if (this.agents.length > 1)
        this.agents.splice(index, 1);
    },

    submit() {
      var data = JSON.parse(JSON.stringify(this.form))
      data['agentID'] = this.agents.filter(a => !isNaN(a.ID) && a.ID > 0).map(a => a.ID);
      data['trainingTime'] = data.trainingTime['HH'] + ":" + data.trainingTime['mm'] + ":" + data.trainingTime['ss'];
      let action = (!this.ID) ? 'CPD/createTraining' : 'CPD/editTraining';
      this.$store.dispatch(action, data)
        .then((result) => {
          this.$router.replace({ name: 'CPD List', params: { isSuccess: true } });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    convertToTranslateKey(key) {
      return this.$t(`adm.cpd.${key}`);
    }
  },

  computed: {
    ...mapGetters('CPD', [
      'getTranslated'
    ]),

    trainingType() {
      return this.getTranslated(this.$i18n.locale, 'trainingType');
    }
  },
  watch: {
    selectedProvider(newValue) {
      Vue.set(this.form, 'providerID', newValue.ID);
    }
  },


  data() {
    return {
      agents: [{ ID: -1 }],
      columnWidth: 10,
      locked: false,
      selectedProvider: {
        ID: -1
      },
      trainingTime: {
        'HH': '00',
        'mm': '00',
        'ss': '00'
      },
      form: {
        providerName: '',
        providerID: -1,
        trainingName: '',
        trainingType: 'N',
        trainingDate: moment().format('YYYY-MM-DD'),
        trainingTime: moment().format('HH:mm:ss'),
        point: 0
      },
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Adm/CPD/components/TrainingCreate.vue